<app-header></app-header>
<app-loader></app-loader>
<app-success-popup></app-success-popup>
<router-outlet></router-outlet>
<app-footer></app-footer>
